export default [
    {
        path: 'cadastro-campanha',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-cadastro-campanha' */ '@/views/imunizacao/cadastro-campanha/Index'),
        redirect: 'cadastro-campanha/index',
        children: [
            {
                name: 'imunizacao-cadastro-campanha-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-cadastro-campanha' */ '@/views/imunizacao/cadastro-campanha/List.vue'),
            },
            {
                name: 'imunizacao-cadastro-campanha-create',
                path: 'create',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-cadastro-campanha' */ '@/views/imunizacao/cadastro-campanha/Form.vue'),
            },
            {
                name: 'imunizacao-cadastro-campanha-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-cadastro-campanha' */ '@/views/imunizacao/cadastro-campanha/Form.vue'),
            },
        ],
    },
]